// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../work/modules/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".feature-columns-section__column[data-v-cb790cfe]:last-child:before{content:none}@media screen and (min-width:768px){.feature-columns-section__column[data-v-cb790cfe]:last-child,.feature-columns-section__column[data-v-cb790cfe]:nth-child(3n){border-right:0}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
